// @vendors
import { hubConnection } from 'signalr-no-jquery';
import type { Connection } from 'signalr-no-jquery';

export const createConnection = (hubUrl: string) => hubConnection(hubUrl);

export const createHub = (connection: Connection, hubName: string) => connection.createHubProxy(hubName);
